import NProgress from 'nprogress'
import configMeta from '@src/config/meta'
import store from '@store'
import router from '@router'
import openDialog from '@src/plugins/global-dialog.js'

export const routerConfig = {
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0,
      }
    }
  },
}

export async function routerBeforeEach(routeTo, routeFrom, next) {
  const routeMeta = {
    ...configMeta,
    ...routeTo.meta,
  }

  if (routeMeta.isNullPage) {
    return next()
  } else {
    const startNProgress = () => {
      if (routeFrom.name !== null) {
        NProgress.start()
        router.app.$globalPageLoading = true
      }
    }

    const checkLoginPage = () => {
      const isLoginPage = routeMeta.isLoginPage

      if (isLoginPage && !(isLoginPage && store.getters['auth/isLoggedIn'])) {
        return next({
          path: '/login',
          query: { redirectFrom: routeTo.fullPath },
          replace: true,
        })
      }
    }

    const checkLogoutPage = () => {
      const isLogoutPage = routeMeta.isLogoutPage

      if (isLogoutPage && !(isLogoutPage && !store.getters['auth/isLoggedIn'])) {
        // 如果有redirectTo，就不會直接跳/member，會跳這邊
        if (window.localStorage.getItem('redirectTo')) {
          let localStorageRedirectTo = JSON.parse(window.localStorage.getItem('redirectTo'))
          window.localStorage.removeItem('redirectTo')
          if (Object.keys(localStorageRedirectTo).length > 0 && 'redirectFrom' in localStorageRedirectTo) {
            return next({ path: localStorageRedirectTo.redirectFrom.replace(window.location.origin, "") })
          } else {
            return next({ path: '/member' })
          }
        }
        return next({ path: '/member' })
      }
    }

    const checkLoginWordpressPage = () => {
      const isLoginWordpressPage = routeMeta.isLoginWordpressPage

      if (isLoginWordpressPage && !(isLoginWordpressPage && store.getters['auth/isLoggedIn'])) {
        return next({
          path: '/shop/login',
          query: { redirectFrom: routeTo.fullPath },
          replace: true,
        })
      }
    }

    const checkLogoutWordpressPage = () => {
      const isLogoutWordpressPage = routeMeta.isLogoutWordpressPage

      if (isLogoutWordpressPage && !(isLogoutWordpressPage && !store.getters['auth/isLoggedIn'])) {
        return next({ path: '/shop/member' })
      }
    }

    const checkDevelopmentPage = () => {
      const isDevelopmentPage = routeMeta.isDevelopmentPage

      if (isDevelopmentPage && !(isDevelopmentPage && process.env.NODE_ENV === 'development')) {
        return next({ path: '/404' })
      }
    }

    // const checkisCanShowPage = () => {
    //   const modePage = routeMeta.modePage;
    //   if(process.env.VUE_APP_MODE !== modePage) {
    //     return next({ path: '/404' })
    //   }
    // }

    startNProgress()

    checkDevelopmentPage()
    checkLoginPage()
    checkLoginWordpressPage()
    checkLogoutPage()
    checkLogoutWordpressPage()
    // checkisCanShowPage()

    // autoOpenGlobalDialog()

    return next()
  }
}

export async function routerBeforeResolve(routeTo, routeFrom, next) {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              if (routeFrom.name === args[0].name) {
                NProgress.done()
                router.app.$globalPageLoading = false
              }
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }

  function openLeaveWarningDialog() {
    openDialog('DialogLeaveWarning', {
      cartType: '',
      value: {},
      cart: {},
      next,
    })
    NProgress.done()
  }

  // 提示預約尚未完成
  if (routeFrom.name === 'add-reservation') {
    if (routeTo.name === 'reservation' || routeTo.name === 'reservation-item' || routeTo.name === 'reservation-checkout') {
      next()
    } else {
      openLeaveWarningDialog()
    }
  } else if (routeFrom.name === 'reservation-checkout') {
    if (routeTo.name === 'reservation-checkout-detail' || routeTo.name === 'reservation-item') {
      next()
    } else {
      openLeaveWarningDialog()
    }
  } else {
    next()
  }
}

export async function routerBeforeResolveJtails(routeTo, routeFrom, next) {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              if (routeFrom.name === args[0].name) {
                NProgress.done()
                router.app.$globalPageLoading = false
              }
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }

  function openLeaveWarningDialog() {
    openDialog('DialogLeaveWarning', {
      cartType: '',
      value: {},
      cart: {},
      next,
    })
    NProgress.done()
  }

  // 提示預約尚未完成
  if (routeFrom.name === 'add-reservation') {
    if (routeTo.name === 'reservation' || routeTo.name === 'reservation-item' || routeTo.name === 'reservation-checkout') {
      next()
    } else {
      openLeaveWarningDialog()
    }
  } else if (routeFrom.name === 'reservation-checkout') {
    if (routeTo.name === 'reservation-checkout-detail' || routeTo.name === 'reservation-item') {
      next()
    } else {
      openLeaveWarningDialog()
    }
  } else {
    next()
  }
}

export async function routerAfterEach(routeTo, routeFrom, next) {
  NProgress.done()
  router.app.$globalPageLoading = false
}
